<template lang="html">
  <div>
    <div class="container" style="border-bottom:none;">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
      >
        <el-col :span="12">
          <div class="grid-content">
            <h3>{{pageTitle}}</h3>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="form-container">
        <el-form
          ref="nodeForm"
          :model="nodeForm"
          :rules="nodeFormRules"
          label-position="right"
          label-width="120px"
        >
          <h5>基本信息</h5>
          <el-form-item
            label="标题"
            prop="title"
          >
            <el-input
              v-model="nodeForm.title"
              placeholder="主题的标题"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="简介"
            prop="description"
            placeholder="主题的简介"
          >
            <el-input
              type="textarea"
              v-model="nodeForm.description"
              :autosize="{ minRows: 3, maxRows: 40 }"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="封面图"
            prop="cover"
            ref="uploadCover"
          >
            <el-input
              v-model="nodeForm.cover"
              placeholder="主题封面图ID"
              style="display:none;"
            ></el-input>
            <file-uploader
              :showSlug="showSlug"
              file-type="Image"
              text="上传主题封面"
              tip="只能上传jpg/png文件，且不超过2M；图片长宽为: 1168px * 524px"
              list-type="picture"
              :limit="1"
              :id-list="[nodeForm.cover]"
              :size-limit="2 * 1024 * 1024"
              :allowed-types="['image/jpeg', 'image/jpg', 'image/png']"
              @upload-success="handleCoverUploadSuccess"
              @file-removed="handleCoverRemoved"
            />
          </el-form-item>
          <el-form-item
            v-if="mode=='update'"
            label="发布时间"
            pop="created"
          >
            <el-input
              disabled
              v-model="nodeForm.created"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否隐藏"
            prop="hidden"
          >
            <el-switch
              v-model="nodeForm.hidden"
            ></el-switch>
          </el-form-item>
          <h5>包含单集</h5>
          <el-form-item
            label="添加单集"
            pop="episode_ids"
          >
            <el-autocomplete
              style="width:100%"
              v-model="state"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="true"
              placeholder="输入单集节目标题"
              @input="autocompleteInputChange"
              @select="handleSelect"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-autocomplete>
          </el-form-item>
          <template v-if="episodeIds.length>0">
            <el-form-item
              label="管理单集"
              pop=""
            >
              <el-tree
                ref="episodeIds"
                :data="episodeIds"
                node-key="episodeId"
                :highlight-current="true"
                :draggable="true"
                :show-checkbox="true"
                :check-on-click-node="true"
                :allow-drop="allowDrop"
                @check-change="checkChange"
                class="tree-container"
              >
                <div slot-scope="node">
                  <draggable-episode-bar
                    :episode-id="node.data.episodeId"
                  />
                </div>
              </el-tree>
              <div class="custom-container">
                <div class="info-bar">
                  <i class="el-icon-info" style="font-size:1.2em;"></i>
                  <p style="margin-left:5px">拖动排序、勾选移除</p>
                </div>
                <div
                  class="remove-btn"
                  :style="{visibility: checkedEpisodes.length>0 ? 'visible' : 'hidden'}"
                >
                  <el-button
                    size="mini"
                    type="warning"
                    plain
                    icon="el-icon-remove"
                    @click="removeCheckedEpisodes"
                  >
                    移除选中单集 ({{checkedEpisodes.length}})
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </template>
           <el-form-item>
              <el-button
                type="primary"
                @click="submitForm()"
              >提交</el-button>
              <span
                v-if="mode=='update'"
                style="float:right;"
              >
                <el-link
                  type="danger"
                  icon="el-icon-delete"
                  :underline="false"
                  @click="remove"
                >删除</el-link>
              </span>
            </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import DraggableEpisodeBar from './draggable-episode-bar.vue'
  import router from '../router'
  import { Message } from 'element-ui'
  import { MessageBox } from 'element-ui'
  import { Link } from 'element-ui'
  import { Tree } from 'element-ui'
  import { Autocomplete } from 'element-ui'
  import FileUploader from './file-uploader.vue'
  import Vue from 'vue'
  Vue.use(Link)
  Vue.use(Tree)
  Vue.use(Autocomplete)
  
  export default {
    components: {
      DraggableEpisodeBar,
      FileUploader
    },
    props: {
      mode: {
        type: String,
        default: 'update' // 可选值: 'create'
      }
    },
    data () {
      return {
        pageTitle: this.mode=='update' ? '修改专题' : '新建专题',
        showSlug: this.$route.params.slug,
        nodeForm: {},
        nodeFormRules: {
          title: [
            { required: false, message: '请输入标题', trigger: 'blur' },
            { max: 20, message: '长度不超过20个字符', trigger: 'blur' }
          ],
          cover: [
            { required: false, message: '请上传封面图', trigger: 'blur' },
          ],
          description: [
            { required: true, message: '请输入简介', trigger: 'blur' },
            { max: 2000, message: '长度不超过2000个字符', trigger: 'blur' }
          ],
        },
        episodeIds: [],
        episodes: [],
        state: '',
        checkedEpisodes: [] // 选中的单集列表
      }
    },
    computed: {},
    methods: {
      submitForm: function () {
        this.$refs.nodeForm.validate((valid) => {
          if (valid) {
            window.console.log("valid:", valid)
            switch (this.mode) {
              case 'create':
                this.createTopic()
                break
              case 'update':
                this.updateTopic()
                break
              default:
                break;
            }
          } else {
            window.console.log(valid)
            Message.error({
              message: `请检查表单填写是否正确、完整`
            })
          }
        })
      },
      createTopic: function () {
        let form = this.nodeForm
        switch (this.showSlug) {
          case 'sanhao':
            form.show = 2
            break;
          case 'nong':
            form.show = 1
            break
          default:
            break;
        }
        form.show = this.showSlug == 'sanhao' ? 2 : 1
        window.console.log(`FORM数据:`, form)
        this.$api.topic.create(
          form
        ).then(res => {
          window.console.log("主题创建成功")
          window.console.log(res)
          router.replace({
            name: 'ResultSuccess',
            params: {
              title: '成功',
              subTitle: '主题已创建',
              action: {
                title: '返回主题列表',
                routeName: 'TopicList'
              }
            }
          })
        })
      },
      updateTopic: function () {
        this.$api.topic.update(
          this.nodeForm.id, this.nodeForm
        ).then(res => {
          window.console.log("主题更新成功")
          window.console.log(res)
          router.replace({
            name: 'ResultSuccess',
            params: {
              title: '成功',
              subTitle: '主题已更新',
              action: {
                title: '返回主题列表',
                routeName: 'TopicList'
              }
            }
          })
        })
      },
      remove: function () {
        let that = this
        window.console.log("remove")
        MessageBox.confirm('此操作将永久删除，是否确定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.console.log("开始删除...")
          that.$api.topic.delete(
            that.nodeForm.id
          ).then(res => {
            window.console.log("删除成功")
            window.console.log(res)
            router.replace({
              name: 'ResultSuccess',
              params: {
                title: '成功',
                subTitle: '主题已删除',
                action: {
                  title: '返回主题列表',
                  routeName: 'TopicList'
                }
              }
            })
          }).catch(err => {
            window.console.log("删除失败")
            window.console.log(err)
          })
          // Message.success({
          //   message: '删除成功!'
          // });
        }).catch(() => {
          Message.info({
            message: '已取消删除'
          });          
        })
      },
      allowDrop: function (draggingNode, dropNode, Type) {
        // 检查是否能够被放下（拖放时）
        if (Type == 'inner') {
          return false
        } else {
          return true
        }
      },
      autocompleteInputChange: function (keyword) {
        window.console.log("autocompleteInputChange", keyword)
        this.getEpisodes(keyword)
      },
      querySearchAsync: function (queryString, cb) {
        window.console.log("开始过滤查询", queryString)
        if (!queryString) {
          this.getEpisodes().then(res => {
            cb(res)
          })
        } else {
          let episodes = this.episodes
          let results = episodes
          // let results = queryString ? episodes.filter(
          //   this.createStateFilter(queryString)) : episodes
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            cb(results)
          }, 0.5 * 1000)
          // cb(results)
        }
      },
      // createStateFilter(queryString) {
      //   return (state) => {
      //     return (state.value.toString().toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      //   }
      // },
      getEpisodes: function (keyword) {
        return new Promise((resolve, reject) => {
          let params = {
            show__slug: this.showSlug
          }
          if (keyword) {
            params.search = keyword
          }
          this.$api.episode.list(params)
          .then(res => {
            window.console.log("获取指定 EPISODE LIST 成功", res.data)
            if (res.data.count > 0) {
              let results = res.data.results
              let theEpisodes = []
              for (let i = 0; i < results.length; i++) {
                const item = results[i];
                window.console.log("ITEM:", item)
                let obj = {} // 临时对象
                obj['value'] = item['title']
                obj['id'] = item['id']
                window.console.log("OBJ:", obj)
                theEpisodes.push(obj)
              }
              window.console.log(`theEpisodes:`, theEpisodes)
              this.episodes = theEpisodes
              window.console.log(`this.episodes:`, this.episodes)
              resolve(theEpisodes)
            }
          })
          .catch(err => {
            reject(err)
          })
        })
      },
      handleSelect: function (e) {
        window.console.log("点击下拉选项:", e)
        // 检查选中的 episodeId 是否已在列表中
        let included = this.episodeIds.some(function(currentValue) {
          return currentValue.episodeId == e.id
        })

        if (included) {
          Message.error({
            message: '该单集已加入此主题'
          })
          this.state = '' // 清空输入框内容
        } else {
          this.$set(
            this.episodeIds,
            this.episodeIds.length,
            {episodeId: e.id}
          )
          Message.success({
            message: '成功添加到此主题'
          })
          this.state = ''
        }
        window.console.log('this.episodeIds:', this.episodeIds)
      },
      checkChange: function (data, node) {
        window.console.log("checkChange:")
        window.console.log(data, node)
        this.checkedEpisodes = this.$refs.episodeIds.getCheckedNodes()
      },
      removeCheckedEpisodes: function () {
        let current = this.episodeIds
        window.console.log('current:', current)
        let toRemove = this.checkedEpisodes
        window.console.log('toRemove:', toRemove)
        let newArr = []
        for (let i = 0; i < current.length; i++) {
          let inRemove = false // 是否在应删列表中
          const item = current[i]
          for (let i2 = 0; i2 < toRemove.length; i2++) {
            const item2 = toRemove[i2]
            if (item2.episodeId == item.episodeId) {
              inRemove = true
            }
          }
          if (!inRemove) {
            newArr.push(item)
          }   
        }
        window.console.log('newArr:', newArr)
        this.episodeIds = newArr
        this.checkedEpisodes = []
      },
      handleCoverRemoved: function (event) {
        window.console.log("封面图片已经被删除")
        window.console.log(event.fileName)
      },
      handleCoverUploadSuccess: function (event) {
        window.console.log("封面上传成功")
        window.console.log(event.fileName)
        window.console.log(event.fileId)
        this.nodeForm.cover = event.fileId
        // this.draft.cover = event.fileId
        this.$refs.uploadCover.clearValidate()
      }
    },
    watch: {
      'episodeIds': function (episodeIds) {
        let episode_ids = []
        for (let i = 0; i < episodeIds.length; i++) {
          const element = episodeIds[i];
          episode_ids.push(element.episodeId)
        }
        this.nodeForm.episode_ids = episode_ids
        window.console.log("this.nodeForm.episode_ids:", this.nodeForm.episode_ids)
      }
      // 'checkedEpisodes': function (checkedEpisodes) {
      //   if (checkedEpisodes.length > 0) {
      //     window.console.log("已选中单集列表数量 > 1")
      //   }
      // }
    },
    mounted () {
      let that = this
      switch (that.mode) {
        case 'create':
          window.console.log("进入模式:", that.mode)
          break
        case 'update':
          window.console.log("进入模式:", that.mode)
          that.$api.topic.detail(that.$route.params.id)
          .then(res => {
            window.console.log("获取到Topic Detail")
            window.console.log(res.data)
            let nodeForm = res.data
            let episodeIds = []
            let id = 0
            for (let i = 0; i < nodeForm['episode_ids'].length; i++) {
              const element = nodeForm['episode_ids'][i];
              episodeIds.push({
                id: id,
                label: `节目ID: ${element}`,
                episodeId: element
              })
              id += 1
            }
            that.nodeForm = nodeForm
            that.episodeIds = episodeIds
          })
          break
        default:
          break;
      }
    }
  }
</script>

<style lang="css" scoped>
.tree-container {
  border: 1px dashed #DCDFE6;
  padding: 5px;
  border-radius: 4px;
}
.custom-container {
  margin-top: 5px;
  line-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  align-content: center;
  vertical-align: middle;
  /* align-items: flex-end; */
}
.info-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #9a9da3;
  font-size: 0.85em;
}
</style>
